import React from "react";
import { PageHero, SectionHeading } from "../components/Sections";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { EnquiryDialog } from "../components/LeadForm";
import { Briefcase, MapPin, TrendingUp, Users } from "lucide-react";

const openings = [
  { title: "Relationship Executive", type: "Full-time", location: "Multiple Locations", desc: "Assist customers through their loan/insurance enquiry journey with clarity and compliance." },
  { title: "Tele-caller / Support", type: "Full-time", location: "Remote / Office", desc: "Handle inbound enquiries and provide first-level assistance to applicants." },
  { title: "Partnerships Associate", type: "Full-time", location: "Head Office", desc: "Coordinate with authorised lending and insurance partners." },
];

const perks = [
  { icon: TrendingUp, title: "Growth", desc: "Learn and grow with a fast-moving fintech facilitation platform." },
  { icon: Users, title: "Great Team", desc: "Work with a supportive, mission-driven team." },
  { icon: Briefcase, title: "Meaningful Work", desc: "Help Indians access financial products responsibly." },
];

export default function Career() {
  return (
    <div>
      <PageHero title="Let's Start Your Career"
        subtitle="Want to work with Loansupportindia? Welcome — show your excellence and we will grow together."
        crumbs={[{ label: "Careers" }]} />
      <section className="section-pad">
        <div className="container-page">
          <SectionHeading eyebrow="Why Join Us" title="Grow with us" />
          <div className="grid gap-6 md:grid-cols-3">
            {perks.map((p) => (
              <Card key={p.title} className="border p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary">
                  <p.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold">{p.title}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground">{p.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>
      <section className="section-pad bg-secondary/40">
        <div className="container-page">
          <SectionHeading eyebrow="Open Positions" title="Current openings" />
          <div className="space-y-4">
            {openings.map((o) => (
              <Card key={o.title} className="flex flex-col gap-4 border p-6 md:flex-row md:items-center md:justify-between">
                <div>
                  <h3 className="font-heading text-lg font-semibold">{o.title}</h3>
                  <p className="mt-1 text-sm text-muted-foreground">{o.desc}</p>
                  <div className="mt-3 flex flex-wrap gap-4 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1.5"><Briefcase className="h-3.5 w-3.5" />{o.type}</span>
                    <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />{o.location}</span>
                  </div>
                </div>
                <EnquiryDialog trigger={<Button className="shrink-0">Apply / Join Us</Button>} defaultType="Other" />
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
